module.exports = __webpack_public_path__ + "static/switch-23e2325cf5d02495f31bbea0d59ce532.png";